<template>
  <div id="nav">
    <!-- :include="['NewsList']" -->
    <keep-alive :include="keepAliveKey">
      <router-view />
    </keep-alive>
    <!-- <router-view v-if="!$route.meta.keepAlive" /> -->
  </div>
</template>

<script>

import { mapState } from "vuex";
export default {
  name: "App",
  computed: {
    ...mapState(["keepAliveKey"])
  },
  mounted() {
    window.onload = function() {
    // 阻止双击放大行为
      var lastTouchEnd = 0;
      document.addEventListener('touchstart', function(event) {
        if (event.touches.length > 1) {
          event.preventDefault();
        }
      });
      document.addEventListener('touchend', function(event) {
        var now = (new Date()).getTime();
        if (now - lastTouchEnd <= 300) {
          event.preventDefault();
        }
        lastTouchEnd = now;
      }, false);

      // 阻止双指进行缩放大行为
      document.addEventListener('gesturestart', function(event) {
        event.preventDefault();
      });
    }
  }
};
</script>

<style lang="scss" scped>
// 黑白滤镜
// body{
//   filter: grayscale(1);
// }
</style>
